import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import classNames from 'classnames';
import MemberPriceIcon from './MemberPriceIcon';
// 有多少位数的钱,就有多少问号
const getMarkFromPrice = (price: number) => {
    const priceInt1 = parseInt(`${price}`);
    const len = `${priceInt1}`.length;
    let val = ``;
    for (let i = 0; i < len; i++) {
        val += '?';
    }
    return val;
};
export default function PriceBox({
    item = {},
    TextA = {},
    priceMember,
    priceNormal,
    priceCompareAt,
    locale,
}: {
    item: any;
    TextA?: any;
    priceMember: number;
    priceNormal: number;
    priceCompareAt: number;
    locale: string;
}) {
    const memberPriceShowAll = item.memberPriceShowAll === 'Y'; //是否展示全部价格
    const priceShowAll = item.priceShowAll === 'Y'; //是否展示全部价格
    const compareAtPriceShowAll = item.compareAtPriceShowAll === 'Y'; //是否展示全部价格
    const isShow_priceMember = !!priceMember; //是否展示会员价
    let isShow_priceNormal = false; //是否展示售价
    let isShow_priceCompareAt = false; //是否展示划线价
    const priceEndTips = TextA.priceEndTips;

    if (priceNormal && priceNormal !== priceMember) {
        isShow_priceNormal = true;
    }
    const normal_flag1 = priceCompareAt > priceNormal || !priceNormal; //不存在售价,或者存在售价,但划线价大于售价
    const member_flag1 = priceMember !== priceCompareAt; //会员价不能等于划线价
    if (priceCompareAt && normal_flag1 && member_flag1) {
        isShow_priceCompareAt = true;
    }
    const memberCornerMarkerText = item.memberCornerMarkerText;
    const isShow_price_line3 = isShow_priceNormal && isShow_priceCompareAt && isShow_priceMember;
    const showPriceEndTips = priceEndTips && locale === 'jp';

    const classes = classNames('member-product-scene-item-price-box', {
        'member-product-scene-item-price-member-hide': !priceMember,
        'member-product-scene-item-price-normal-box1-hide': !isShow_priceNormal,
        'member-product-scene-item-price-normal-box2-hide': !isShow_priceCompareAt,
        'member-product-scene-item-price-line3': isShow_price_line3, //3个价格
    });

    return (
        <div className={classes} key={`${isShow_priceMember}-${isShow_priceNormal}-${isShow_priceCompareAt}`}>
            <div className={`member-product-scene-item-price-member`}>
                <span className="member-product-scene-item-price-member-box1">
                    {memberPriceShowAll ? FormatMoneyLocal(priceMember, locale) : getMarkFromPrice(priceMember)}
                    {showPriceEndTips && <span className="member-product-scene-item-price-member-box1-ms1">{priceEndTips}</span>}
                </span>
                {memberCornerMarkerText && <MemberPriceIcon memberCornerMarkerText={memberCornerMarkerText} />}
            </div>
            <div className={`member-product-scene-item-price-normal`}>
                <span className={`member-product-scene-item-price-normal-box1`}>
                    <span className="member-product-scene-item-price-normal-box1-ms1">
                        {priceShowAll ? FormatMoneyLocal(priceNormal, locale) : getMarkFromPrice(priceNormal)}
                        {showPriceEndTips && <>{priceEndTips}</>}
                    </span>
                    {isShow_price_line3 && <span className="member-product-scene-item-price-normal-box1-ms2">{TextA.NonMemberPrice}</span>}
                </span>
                <span className={`member-product-scene-item-price-normal-box2`}>
                    <span className="member-product-scene-item-price-normal-box2-ms1">
                        {compareAtPriceShowAll ? FormatMoneyLocal(priceCompareAt, locale) : getMarkFromPrice(priceCompareAt)}
                        {showPriceEndTips && <>{priceEndTips}</>}
                    </span>
                </span>
            </div>
        </div>
    );
}
